import { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../api";

const DoctorSelect = ({ 
  value, selectedId, onChange, onSelectID, 
  placeholder = "Select Doctor", ...props 
}) => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/doctors`);
        setDoctors(response.data);
      } catch (error) {
        setDoctors([]);
      } finally {
        setLoading(false);
      }
    };
    fetchDoctors();
  }, []);


  const displayValue = value
    ? value
    : (selectedId ? doctors.find(doc => doc._id === selectedId || doc.id === selectedId)?.docName : undefined);

  return (
    <Select
      showSearch
      value={displayValue}
      onChange={(val) => {
        if (onChange) onChange(val);
        if (onSelectID) {
          const selectedDoctor = doctors.find(doc => doc.docName === val);
          onSelectID(selectedDoctor?._id || selectedDoctor?.id || null);
        }
      }}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      {doctors
        .filter((doctor) => doctor?.status !== "inactive" || doctor._id === selectedId || doctor.id === selectedId || doctor.docName === value)
        .map((doctor) => (
          <Select.Option key={doctor._id || doctor.id} value={doctor.docName}>
            {doctor?.docName} {doctor?.status === "inactive" ? "(Disabled)" : ""}
          </Select.Option>
        ))}
    </Select>
  );
};

export default DoctorSelect;